import { render } from "./OrderDetailComponent.vue?vue&type=template&id=b9c3366a"
import script from "./OrderDetailComponent.vue?vue&type=script&lang=js"
export * from "./OrderDetailComponent.vue?vue&type=script&lang=js"

import "./OrderDetailComponent.vue?vue&type=style&index=0&id=b9c3366a&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__